import { useCallback } from 'react';

import {
  rawTrackEngagementEvent,
  rawTrackViewEvent,
} from '../../services/tracking/pulse';

export const useEngagementTracking = (elementType: string) => {
  const trackView = useCallback(() => {
    rawTrackViewEvent({
      object: {
        id: elementType,
        type: 'UIElement',
        elementType,
      },
    });
  }, [elementType]);

  const trackClick = useCallback(
    (intent: string) => {
      rawTrackEngagementEvent({
        action: 'Click',
        intent,
        object: {
          id: elementType,
          type: 'UIElement',
          elementType,
        },
      });
    },
    [elementType]
  );

  return {
    trackView,
    trackClick,
  };
};
